type Snapshot = { status: string; ideaRounds: number };

/**
 * What changed between two polls of a thought: a new round of ideas arrived, or
 * a «Ещё идеи» round failed (the API puts the thought back to ready with an
 * error and the old ideas). `prev` is undefined on the first load.
 */
export function roundOutcome(
  prev: Snapshot | undefined,
  next: Snapshot & { error: string | null },
): 'new_round' | 'failed' | null {
  if (!prev) return null;
  if (next.ideaRounds > prev.ideaRounds) return 'new_round';
  if (prev.status === 'ideating' && next.status === 'ready' && next.error !== null) return 'failed';
  return null;
}

/** Idea cards by round, rounds and cards in order. */
export function groupByRound<T extends { round: number; position: number }>(
  ideas: ReadonlyArray<T>,
): Array<{ round: number; ideas: T[] }> {
  const sorted = [...ideas].sort((a, b) => a.round - b.round || a.position - b.position);
  const groups: Array<{ round: number; ideas: T[] }> = [];
  for (const idea of sorted) {
    const last = groups[groups.length - 1];
    if (last && last.round === idea.round) last.ideas.push(idea);
    else groups.push({ round: idea.round, ideas: [idea] });
  }
  return groups;
}
